import SIM from '../../sim/core';
import blockingCodeUtils from '../../utils/sim/blocking_code';
import storeUtils from '../../utils/store';
import MNXAvailability from '../../sim/parser-mnx-availability';
import MNXGeometry from '../../sim/parser-mnx-geometry';

const ismConfig = storeUtils.get('ism_config');
const eventPrices = storeUtils.get('event_prices');
const eventConfig = storeUtils.get('event_config');

const validBlockingCodeIds = blockingCodeUtils.eventPricesToBlockingCodes(eventPrices);
const validPriceCategoryIds = Object.keys(eventPrices.priceCategories);
const mnxavailability = MNXAvailability(validPriceCategoryIds, validBlockingCodeIds);

ismConfig.availability.parser = mnxavailability;
ismConfig.geometry.parser = MNXGeometry;
ismConfig.system.showSeats = !eventConfig.seatmapDisplayOverviewMode;

// pass the config to the SIM library
SIM.setConfig(ismConfig);

// emit the event that initializes loading of the map
SIM.init();



// WEBPACK FOOTER //
// ./frontend/react/apps/edp/sim.js